'use strict';

require('./bootstrap');
require('./services/SecurityService');
require('./services/OAuth2LoginService');
